/* Quantity selector — one dropdown driving the hidden quantity input posted
   with the product form. All 1–20 prices are pre-formatted by Liquid in the
   active market's fixed currency, so nothing is computed or converted here. */
if (!customElements.get('cm-buy-for')) {
  customElements.define(
    'cm-buy-for',
    class CmBuyFor extends HTMLElement {
      connectedCallback() {
        this.data = JSON.parse(this.querySelector('[data-cm-buy-for-data]').textContent);
        this.select = this.querySelector('[data-cm-select]');
        this.quantityInput = this.querySelector('[data-cm-quantity]');
        this.unitEl = this.querySelector('[data-cm-unit]');
        this.totalEl = this.querySelector('[data-cm-total]');
        this.savingEl = this.querySelector('[data-cm-saving]');
        this.savingAmountEl = this.querySelector('[data-cm-saving-amount]');
        this.commercialNote = this.querySelector('[data-cm-commercial-note]');

        this.applyInitialQuantity();
        this.select.addEventListener('change', () => this.refresh());

        // Dawn can rewrite the submit button label on cart updates; re-apply
        // after its handlers have run. PUB_SUB_EVENTS/subscribe are top-level
        // const/function declarations — script-global, not window properties.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(() => this.applyButtonText(), 0));
        }

        this.refresh();
      }

      /* ?qty=N preselects a quantity. ?buying_for=gym|commercial is the older
         form the homepage CTAs still use — map it to that tier's first
         quantity so those links keep working now the tabs are gone. */
      applyInitialQuantity() {
        const params = new URLSearchParams(window.location.search);
        const buyingFor = { gym: 4, commercial: 10 }[params.get('buying_for')];
        const requested = parseInt(params.get('qty'), 10);
        const wanted = Number.isFinite(requested) ? requested : buyingFor;
        if (!wanted) return;
        const clamped = Math.min(Math.max(wanted, 1), this.data.rows.length);
        this.select.value = String(clamped);
      }

      get quantity() {
        return parseInt(this.select.value, 10) || 1;
      }

      refresh() {
        const quantity = this.quantity;
        const row = this.data.rows[quantity - 1];

        this.unitEl.textContent = row.unit;
        this.totalEl.textContent = row.total;
        this.savingEl.hidden = row.savingCents <= 0;
        this.savingAmountEl.textContent = row.saving;
        // Informational only, and only over 10 — 10 itself is the tier
        // boundary, not an "order over 10 units".
        this.commercialNote.hidden = quantity <= 10;
        this.quantityInput.value = quantity;
        this.applyButtonText();
        this.updateQuoteLink(quantity);
        this.updateInlineTotal(row.total);
      }

      // Mirrors the total next to the Add to cart button on mobile, where
      // this widget's own total further up scrolls out of view — see
      // buy-buttons.liquid.
      updateInlineTotal(total) {
        const inlineTotal = document.getElementById(`InlineTotal-${this.dataset.sectionId}`);
        if (!inlineTotal) return;
        inlineTotal.hidden = false;
        inlineTotal.querySelector('[data-cm-inline-total-amount]').textContent = total;
      }

      applyButtonText() {
        const button = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
        if (!button || button.hasAttribute('disabled')) return;
        const label = button.querySelector('span');
        if (!label) return;
        const quantity = this.quantity;
        label.textContent = `Add ${quantity} ${quantity === 1 ? 'mirror' : 'mirrors'} to cart`;
      }

      updateQuoteLink(quantity) {
        const link = document.querySelector('[data-cm-quote-link]');
        if (!link) return;
        try {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('qty', quantity);
          link.href = url.pathname + url.search + '#quote';
        } catch {
          /* leave the static link as rendered */
        }
      }
    }
  );
}
